<template>
  <div class="partner-holder text-white flex flex-col items-center px-2 md:px-6">
    <div v-for="(partner, index) in partners" :key="index" class="partner-item">
      <div class="image-container">
        <img class="partner-img" :src="partner.image" :alt="partner.name" />
      </div>
      <div class="partner-body text-center md:text-left">
        <h3 class="partner-title">{{ partner.name }}</h3>
        <a v-if="partner.link" :href="partner.link" target="_blank" class="partner-link ">{{ partner.link }}</a>
        <p class="partner-description whitespace-pre-line">{{ $t('partners.' + partner.description) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import b2m from './b2m.jpeg';
import banzey from './banzey.jpeg';
import iyam from './iyam.jpg';
import mklbeauty from './mklbeauty.jpg';
import plaisirBachiques from './plaisir-bachiques.jpg';
import muntu from './muntuwarriors.png';

export default {
  data() {
    return {
      partners: [
        { name: 'Plaisirs Bachiques', link: 'https://www.plaisirs-bachiques.fr/', image: plaisirBachiques, description: 'plaisir_bachiques' },
        { name: 'Iyam', link: 'https://instagram.com/iyam_paris?igshid=YmMyMTA2M2Y=', image: iyam, description: 'iyam' },
        { name: 'GMLK Paris', link: 'https://www.gmlk-paris.com/', image: mklbeauty, description: 'gmlk' },
        { name: 'B2M', link: '', image: b2m, description: 'b2m' },
        { name: 'Alfonzo Banzey', link: '', image: banzey, description: 'banzey' },
        { name: 'Muntu Warriors', link: '', image: muntu, description: 'muntu' }
      ]
    };
  }
};
</script>

<style scoped>
.partner-holder {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
}

.partner-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 2rem;
  width: 100%;
  text-align: center;
}

.image-container {
  width: 19rem;
  height: 19rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  /* border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.2); */
}

.partner-img {
  width: 100%;
  height: 100%;
  /* object-fit: cover; */
  object-position: center;
  transition: transform 0.3s ease-in-out;
}

.partner-img:hover {
  transform: scale(1.1);
}

.partner-body {
  margin-top: 1rem;
  max-width: 80%;
}

.partner-title {
  font-size: 1.5rem;
  font-weight: bold;
}

.partner-link {
  display: block;
  color: #4299e1;
  text-decoration: none;
  font-size: 1rem;
  margin: 0.5rem 0;
  transition: color 0.3s ease-in-out;
}

.partner-link:hover {
  color: #2b6cb0;
}

.partner-description {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
}

/* Responsive */
@media (min-width: 768px) {
  .partner-item {
    flex-direction: row;
    text-align: left;
    align-items: center;
  }

  .image-container {
    width: 12rem;
    height: 12rem;
    margin-right: 2rem;
  }
}
</style>
